const Text = ({ value }: { value?: string }) => {
  return (
    <div>
      {value
        ?.split(', ')
        .filter((part) => part.trim() !== '')
        .join(', ')}
    </div>
  )
}

export default Text
